import axios from 'axios';
import { Location } from './Location';
import memo from 'lodash.memoize';

const LOCATION_GATEWAY_BASE_URL = 'https://api.drtlgi.com/location-gateway';

interface Props {
  zipCode: string;
  isWithinDomesticUS?: boolean;
}

/*
 * This function will fail if a location is not found with the given zip code.
 * This needs to be wrapped in a try/catch block as it will throw an error if
 * the zip code is not found.
 */
async function getLocationFromZip({
  zipCode,
  isWithinDomesticUS = true,
}: Props): Promise<Location | undefined> {
  const queryParams = isWithinDomesticUS ? '?isWithinDomesticUS=true' : '';

  const response = await axios.get<Location>(
    `${LOCATION_GATEWAY_BASE_URL}/postal-codes/${zipCode}${queryParams}`
  );

  return response.data;
}

const memoizedGetLocationFromZip = memo(
  (props: Props) => getLocationFromZip(props),
  ({ zipCode }: Props) => zipCode
);

export { getLocationFromZip, memoizedGetLocationFromZip };
